<template>
    <div class="d-flex flex-column">
        <!-- <v-row
            v-if="canExportRequests()"
            class="ma-0 justify-end ga-8 align-center">
            <v-col
                
                cols="12" class="px-0 d-flex justify-end aling-center ga-4">
                <v-btn
                    prepend-icon="mdi-microsoft-excel"
                    color="info" class=""
                    @click="openDialogForAction('export')"
                >
                    Exportar
                </v-btn>
                <v-btn
                    class=""
                    variant="outlined"
                    prepend-icon="mdi-open-in-new"
                    :to="{ name: 'exports', query: { export_type: 'department-membership-requests', }, }"
                    target="_blank"
                >Ver Exportações</v-btn>
            </v-col>
        </v-row> -->
        <v-row class="ma-0 justify-space-between align-start my-3 ga-4">
            <v-col 
                cols="12" 
                md="6"
                class="px-0 flex-1-1-0"
            >
                <v-select 
                    v-model="filters.status" 
                    label="Estado do pedido" 
                    variant="outlined"
                    :items="statusList" 
                    item-title="name" 
                    item-value="value"
                    :loading="loading"
                    :disabled="loading"
                    hide-details
                    multiple
                    clearable
                    @update:menu="handleStatusMenuUpdate"
                    @click:clear="() => {
                        resetFilters();
                        fetchDepartmentMembershipRequests();
                    }"
                >
                    <template #selection="{item}">
                         <v-icon
                            :icon="item.raw.icon"
                            class="mr-2"
                        />
                        <span>{{ item.title }}</span>
                    </template>
                    <template #item="{ props: itemProps, item }">
                        <v-list-item
                            v-bind="itemProps"
                            :prepend-icon="item.raw.icon"
                        />
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12" md="6" class="px-0  flex-1-1-0">
                <v-autocomplete 
                    v-model="filters.assigned_user_id"
                    label="Colaborador(a) a transferir"
                    variant="outlined"
                    :loading="isLoadingUsersList"
                    :disabled="loading || isLoadingUsersList"
                    :items="usersList"
                    item-value="id"
                    :item-title="(item) => `${item?.worker_code ? item.worker_code : 'Colaborador(a) sem código'} - ${item?.name ? item.name : 'Colaborador(a) sem nome'}`"
                    autocomplete="off"
                    :hint="
                        isLoadingUsersList 
                        ? `Carregando lista de colaboradores ${userListPagination.page ?? 1}/${userListPagination.last_page ?? '??'}... `
                        : `Lista de colaboradores carregada: ${userListPagination.page ?? 1}/${userListPagination.last_page ?? 1}.`
                    "
                    multiple
                    clearable
                    persistent-hint
                    @update:menu="handleAssignedUsersMenuUpdate"
                    @click:clear="handleAssignedUsersClear"
                />
            </v-col>
            

        </v-row>
        <v-row class="ma-0">
            <v-col 
                cols="12"
                class="px-0 d-flex justify-end"
            >
                
                <v-btn
                    prepend-icon="mdi-plus"
                    color="primary"
                    class="mt-4 mb-2"
                    :disabled="!canCreateMembershipRequest"
                    @click="openDialogForAction('create')"
                >
                    Criar Pedido
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table-server
            v-model:items-per-page="filters.per_page"
            v-model:page="filters.page"
            :headers="requests_table_headers"
            :items="requests_list"
            :items-length="filters.total ?? 0"
            :loading="loading"
            :loading-text="`${first_load ? 'Obtendo' : 'Atualizando'} lista de pedidos...`"
            :search="search"
            item-value="name"
            :no-data-text="
                loading_failed
                    ? 'Ocorreu um erro a obter a lista de pedidos'
                    : 'Não foram encontrados pedidos de acordo com os parâmetros de pesquisa.'
            "
            :mobile="mdAndDown"
            :hide-default-footer="true"
            @update:sort-by="(newOrder) => handleSortingUpdate(newOrder)"
        >
            <template #item.created_at="{ item }">
                {{ getDate(item.created_at) }}
            </template>

            <template #item.assigned_user="{item}">
                {{ item?.assigned_user_worker_code ? `${item.assigned_user_worker_code} - ` : "" }}
                {{ item?.assigned_user ?? "Colaborador sem nome" }}
            </template>

            <template #item.departments="{ item }">
                <div>
                    <v-icon
                        :class="[
                            item?.initial_department_denied_at
                                ? 'text-error'
                                : (
                                    item?.initial_department_approved_at
                                        ? 'text-success'
                                        : 'text-warning'
                                ),
                            'mr-2',
                            'rounded-xl',
                        ]"
                    >
                        {{
                            item?.initial_department_denied_at
                                ? "mdi-cancel"
                                : (
                                    item?.initial_department_approved_at
                                        ? "mdi-check-bold"
                                        : "mdi-timer-sand"
                                )
                        }}
                    </v-icon>

                    <span>
                        {{ item?.initial_department || "Sem CC Inicial" }}
                    </span>

                    <v-icon class="mx-4">
                        mdi-ray-start-arrow
                    </v-icon>

                    <span>
                        {{ item.final_department }}
                    </span>

                    <v-icon
                        size="large"
                        :class="[
                            item?.final_department_denied_at
                                && !item?.initial_department_denied_at
                                ? 'text-error'
                                : (
                                    !item?.final_department_denied_at
                                        && item?.initial_department_denied_at
                                        ? 'text-info'
                                        : (
                                            item?.final_department_approved_at
                                                ? 'text-success'
                                                : 'text-warning'
                                        )
                                ),
                            'ml-2',
                            'rounded-xl',
                        ]"
                    >
                        {{
                            item?.final_department_denied_at
                                && !item?.initial_department_denied_at
                                ? "mdi-cancel"
                                : (
                                    item?.initial_department_denied_at
                                        ? "mdi-close"
                                        : (
                                            item?.final_department_approved_at
                                                ? "mdi-check-bold"
                                                : "mdi-timer-sand"
                                        )
                                )
                        }}
                    </v-icon>
                </div>
            </template>

            <template #item.transfer_date="{item}">
                {{ item?.transfer_date?.substring(0,10) }}
            </template>

            <template #item.status="{ item }">
                <div
                    :class="[
                        'rounded',
                        item?.processed_at
                        ? 'bg-success'
                        : item?.initial_department_denied_at
                            || item?.final_department_denied_at
                            ? 'text-error'
                            : (
                                item?.final_department_approved_at
                                    ? 'text-success'
                                    : (
                                        item?.initial_department_approved_at
                                            && !item?.final_department_approved_at
                                            ? 'bg-info'
                                            : 'bg-warning'
                                    )
                            ),
                    ]"
                >
                    <v-icon v-if="item?.processed_at" class="mr-2">mdi-message-check</v-icon>
                    <span class="flex-grow-1">
                        {{
                            item?.processed_at
                            ? "Processado no Primavera"
                            : item?.final_department_denied_at
                                ? "Recusado no CC final"
                                : (
                                    item?.initial_department_denied_at
                                        ? "Recusado no CC inicial"
                                        : (
                                            item?.final_department_approved_at
                                                ? "Aprovado no CC final"
                                                : (
                                                    item?.initial_department_approved_at
                                                        ? "Aprovado no CC inicial"
                                                        : "Criado (aguarda decisão do CC inicial)"
                                                )
                                        )
                                )
                        }}
                    </span>
                </div>
            </template>

            <template #item.by="{ item }">
                <span class="flex-grow-1">
                    {{
                        item?.final_department_denied_at
                            ? item?.final_department_denied_by
                            : (
                                item?.initial_department_denied_at
                                    ? item?.initial_department_denied_by
                                    : (
                                        item?.final_department_approved_at
                                            ? item?.final_department_approved_by
                                            : (
                                                item?.initial_department_approved_at
                                                    ? item?.initial_department_approved_by
                                                    : item?.requested_by
                                            )
                                    )
                            )
                    }}
                </span>
            </template>

            <template #item.actions="{ item }">
                <div
                    class="d-flex flex-column flex-md-row justify-lg-end ga-4 align-center"
                >
                    <v-tooltip
                        v-if="canActOnRequest(item, 'edit')"
                        text="Editar pedido"
                        location="top"
                    >
                        <template #activator="{ props }">
                            <v-btn
                                v-bind="props"
                                icon="mdi-pencil"
                                color="dark"
                                rounded="xl"
                                size="x-small"
                                @click="openDialogForAction('update', item)"
                                :disabled="loading"
                            />
                        </template>
                    </v-tooltip>

                    <v-tooltip
                        v-if="canActOnRequest(item, 'delete')"
                        text="Apagar pedido"
                        location="top"
                    >
                        <template #activator="{ props }">
                            <v-btn
                                v-bind="props"
                                icon="mdi-delete"
                                color="error"
                                variant="outlined"
                                rounded="xl"
                                size="x-small"
                                @click="openDialogForAction('delete', item)"
                                :disabled="loading"
                            />
                        </template>
                    </v-tooltip>

                    <v-tooltip
                        v-if="canActOnRequest(item, 'approve')"
                        text="Aprovar pedido"
                        location="top"
                    >
                        <template #activator="{ props }">
                            <v-btn
                                v-bind="props"
                                icon="mdi-check"
                                color="success"
                                rounded="xl"
                                size="x-small"
                                @click="openDialogForAction('approve', item)"
                                :disabled="loading"
                            />
                        </template>
                    </v-tooltip>

                    <v-tooltip
                        v-if="canActOnRequest(item, 'deny')"
                        text="Recusar pedido"
                        location="top"
                    >
                        <template #activator="{ props }">
                            <v-btn
                                v-bind="props"
                                icon="mdi-cancel"
                                color="error"
                                rounded="xl"
                                size="x-small"
                                @click="openDialogForAction('deny', item)"
                                :disabled="loading"
                            />
                        </template>
                    </v-tooltip>

                    <v-tooltip
                        v-if="canActOnRequest(item, 'process')"
                        text="Indicar que pedido já foi 'Processado' no Primavera"
                        location="top"
                    >
                        <template #activator="{props}">
                            <v-btn
                                v-bind="props"
                                prepend-icon="mdi-send-check"
                                color="success"
                                rounded
                                @click="openDialogForAction('process', item)"
                                class="text-none"
                                :disabled="loading"
                            >
                                Marcar "Processado"
                            </v-btn>
                        </template>
                    </v-tooltip>
                </div>
            </template>
        </v-data-table-server>

        <div class="d-flex justify-end align-center">
            <strong v-if="!first_load">
                {{ filters.from ?? 1 }}
                -
                {{ filters.to ?? filters.per_page ?? 10 }}
                /
                {{ filters.total ?? 0 }}
            </strong>

            <v-pagination
                v-model="filters.page"
                :length="filters.last_page ?? 1"
                :total-visible="0"
                @update:model-value="fetchDepartmentMembershipRequests"
            />
        </div>
    </div>
</template>

<script setup>
import {
    computed,
    onMounted,
    ref,
} from "vue";

import { useDisplay } from "vuetify";
import { useDialog } from "@internal_projects_dd/universal-dialog";
import DepartmentMembershipRequest from "@/api/departments/membership-requests/DepartmentMembershipRequests";
import DepartmentMembershipRequestForm from "@/components/departments/membership/requests/DepartmentMembershipRequestForm.vue";
import DepartmentMembershipRequestExportFields from "@/components/departments/membership/requests/DepartmentMembershipRequestExportFields.vue";
import { getDate } from "../../../../composables/datetime";
import { useSessionStore } from "@/stores/SessionStore";
import User from "@/api/User.js";
defineProps({});

const MEMBERSHIP_REQUEST_PERMISSION_UPDATE =
    "user.department.membership.request.update";

const MEMBERSHIP_REQUEST_PERMISSION_UPDATE_DEPARTMENT = 
    "user.department.membership.request.update.department"

const MEMBERSHIP_REQUEST_PERMISSION_UPDATE_ANY = 
    "user.department.membership.request.update.any";

const MEMBERSHIP_REQUEST_PERMISSION_APPROVE =
    "user.department.membership.request.approve";

const MEMBERSHIP_REQUEST_PERMISSION_APPROVE_DEPARTMENT = 
    "user.department.membership.request.approve.department"

const MEMBERSHIP_REQUEST_PERMISSION_APPROVE_ANY = 
    "user.department.membership.request.approve.any";

const MEMBERSHIP_REQUEST_PERMISSION_DENY =
    "user.department.membership.request.deny";
    
const MEMBERSHIP_REQUEST_PERMISSION_DENY_DEPARTMENT = 
    "user.department.membership.request.deny.department"

const MEMBERSHIP_REQUEST_PERMISSION_DENY_ANY = 
    "user.department.membership.request.deny.any";

const MEMBERSHIP_REQUEST_PERMISSION_CREATE =
    "user.department.membership.request.create";

const MEMBERSHIP_REQUEST_PERMISSION_CREATE_DEPARTMENT =
    "user.department.membership.request.create.department";

const MEMBERSHIP_REQUEST_PERMISSION_CREATE_ANY =
    "user.department.membership.request.create.any";

const MEMBERSHIP_REQUEST_PERMISSION_DELETE_DEPARTMENT = 
    "user.department.membership.request.delete.department";

const MEMBERSHIP_REQUEST_PERMISSION_DELETE_ANY = 
    "user.department.membership.request.delete.any";


const statusList = [
    {
        name: "Aguarda processamento (Aprovado CC final)",
        value: "approved_final",
        icon: "mdi-check-all",
    },
    {
        name: "Aprovado (CC inicial)",
        value: "approved_initial",
        icon: "mdi-check",
    },
    {
        name: "Criado (Aguarda CC inicial)",
        value: "created",
        icon: "mdi-timer-sand"
    },
    {
        name: "Processado",
        value: "processed",
        icon: "mdi-message-check"
    },
    {
        name: "Recusado (CC inicial)",
        value: "denied_initial",
        icon: "mdi-cancel",
    },
    {
        name: "Recusado (CC final)",
        value: "denied_final",
        icon: "mdi-account-cancel"
    },
]

const requests_list = ref([]);
const loading = ref(false);
const first_load = ref(true);
const loading_failed = ref(false);
const search = ref("");
const isLoadingUsersList = ref(false);
const userListPagination = ref({
    from: null,
    to: null,
    last_page: null,
    per_page: 50,
    total: 0,
    page: 1,
});
const usersList = ref([]);

const sessionStore = useSessionStore();

const dialog = useDialog();

const { mdAndDown } = useDisplay();

const requests_table_headers = [
    {
        title: "Criado",
        align: "start",
        sortable: true,
        key: "created_at",
    },
    {
        title: "Colaborador",
        align: "start",
        sortable: true,
        key: "assigned_user",
    },
    {
        title: "Centros de Custo",
        align: "start",
        sortable: true,
        key: "departments",
    },
    {
        title: "Data de Transferência",
        align: "start",
        sortable: true,
        key: "transfer_date",
    },
    {
        title: "Estado",
        align: "center",
        sortable: true,
        key: "status",
        maxWidth: 250,
    },
    {
        title: "Por",
        align: "center",
        sortable: true,
        key: "by",
    },
    {
        title: "Ações",
        align: "start",
        sortable: false,
        key: "actions",
    },
];

const filters = ref({
    search: null,
    order_by: "status",
    order_direction: "desc",
    per_page: 10,
    page: 1,
    from: null,
    to: null,
    last_page: null,
    total: null,
    columns: [],
    status: null,
});

function resetFilters() {
    filters.value = {
        ...filters.value,
        page: 1,
        from: null,
        to: null,
        last_page:  null,
        total: 0,
    }; 
}

function handleStatusMenuUpdate(isOpen) {
    if (isOpen) {
        return;
    }

    resetFilters();

    fetchDepartmentMembershipRequests();
}

function handleSortingUpdate(updatedSorting = {}) {
    updatedSorting = updatedSorting?.at(0);

    if (!updatedSorting) {
        return;
    }

    if (updatedSorting?.key) {
        filters.value.order_by =
            updatedSorting.key;
    }

    if (updatedSorting?.order) {
        filters.value.order_direction =
            updatedSorting.order;
    }

    fetchDepartmentMembershipRequests();
}

async function fetchDepartmentMembershipRequests() {

    if(loading.value) {
        return;
    }
    loading.value = true;
    loading_failed.value = false;

    return DepartmentMembershipRequest
        .all(filters.value)
        .then((response) => {
            const responseIsPaginated =
                response?.data?.data
                && response?.data?.current_page;

            if (responseIsPaginated) {
                requests_list.value =
                    Array.isArray(response.data?.data)
                        ? [...response.data.data]
                        : [];

                filters.value = {
                    ...filters.value,

                    from:
                        response.data?.from
                        ?? 1,

                    to:
                        response?.data?.to
                        ?? filters.value.per_page,

                    page:
                        response?.data?.current_page
                        ?? filters.value.page,

                    last_page:
                        response?.data?.last_page
                        ?? filters.value.last_page,

                    total:
                        response?.data?.total
                        ?? filters.value.total,
                };

                return;
            }

            requests_list.value =
                Array.isArray(response.data)
                    ? [...response.data]
                    : [];
        })
        .catch((error) => {
            loading_failed.value = true;

            console.error(
                "Erro ao carregar pedidos de mudança de base:",
                error?.response?.data || error,
            );
        })
        .finally(() => {
            loading.value = false;
            first_load.value = false;
        });
}

function canCreateMembershipRequest() {
    if (sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_CREATE_ANY)) {
        return true;
    }

    return (
        sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_CREATE_DEPARTMENT)
        && sessionStore.user?.departments?.length > 0
    );
}

function canExportRequests() {
    return sessionStore.hasPermission("user.department.membership.request.export.any")
        || (sessionStore.hasPermission("user.department.membership.request.export.department")
            && sessionStore.user?.departments?.length > 0);
}

function requestCanBeEditedOrDeleted(item) {

    return  !item?.initial_department_approved_at
            && !item?.initial_department_approved_by
            && !item?.initial_department_denied_at
            && !item?.initial_department_denied_by
            && !item?.final_department_approved_at
            && !item?.final_department_approved_by
            && !item?.final_department_denied_at
            && !item?.final_department_denied_by
            && !item?.can_process
            && !item?.processed_at
            && !item?.processed_by_user_id
}

function canEditRequest(item) {
    return (
        requestCanBeEditedOrDeleted(item)
        && (
            // check universal update permission
            sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_UPDATE_ANY)
            // check department specific permission and if user belongs to either
            // department in the request
            || (
                sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_UPDATE_DEPARTMENT)
                && sessionStore.belongsToDepartments([
                    item?.initial_department_id,
                    item?.final_department_id
                ])
            )
        )
    );
}

function canDeleteRequest(item) {

    return (
        requestCanBeEditedOrDeleted(item)
        && (
            // check universal delete permission
            sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_DELETE_ANY)
            // check department specific permission and if user belongs to either
            // department in the request
            || (
                sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_DELETE_DEPARTMENT)
                && sessionStore.belongsToDepartments([
                    item?.initial_department_id,
                    item?.final_department_id
                ])
            )
        )
    )
    ;
}

function canApproveRequest(item, decisionStep = null) {
    decisionStep = decisionStep ?? getDecisionDepartmentType(item);
    return (
        !canProcessRequest(item)
        && requestCanBeApprovedOrDenied(item)
        && (
            sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_APPROVE_ANY)
            || (
                sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_APPROVE_DEPARTMENT)
                && (
                    (
                        ( decisionStep == "initial"
                        && sessionStore.belongsToDepartments(item?.initial_department_id))
                    ) || (
                        (decisionStep == "final"
                        && sessionStore.belongsToDepartments(item?.final_department_id))
                    )
                )
            )
        )
    )
}

function requestCanBeApprovedOrDenied(request) {
    return (
        !request?.initial_department_denied_at
        && !request?.final_department_approved_at
        && !request?.final_department_denied_at
    );
}

function canDenyRequest(item, decisionStep = null) {
    decisionStep = decisionStep ?? getDecisionDepartmentType(item);
    return (
        !canProcessRequest(item)
        && requestCanBeApprovedOrDenied(item)
        && (
            sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_DENY_ANY)
            || (
                sessionStore.hasPermission(MEMBERSHIP_REQUEST_PERMISSION_DENY_DEPARTMENT)
                && (
                    (
                        ( decisionStep == "initial"
                        && sessionStore.belongsToDepartments(item?.initial_department_id))
                    ) || (
                        (decisionStep == "final"
                        && sessionStore.belongsToDepartments(item?.final_department_id))
                    )
                )
            )
        )
    )
}

function canProcessRequest(item) {
    return item?.can_process
            && !item?.processed_at
            && !item?.processed_by_user_id
        ;
}

function canActOnRequest(item, action, decisionStep = null) {
    
    if(["approve", "deny", "refuse"].includes(action)) {
        decisionStep = decisionStep ?? getDecisionDepartmentType(item);
    }

    switch (action) {
        case "approve":
            return canApproveRequest(item, decisionStep);
        
        case "deny":
        case "refuse":
            return canDenyRequest(item, decisionStep);
        
        case "delete":
            return canDeleteRequest(item);

        case "update":
        case "edit":
            return canEditRequest(item);

        case "process":
            return canProcessRequest(item);
        default:
            return false;
    }
}



function getDecisionDepartmentType(item) {
    return (
        item?.initial_department_approved_at
        || item?.initial_department_approved_by_user_id
    )
        ? "final"
        : "initial";
}

const dialogActionStrategies = {
    export: {
        title: "Exportar pedidos",
        confirmActionIcon: "mdi-microsoft-excel",
        confirmActionText: "Exportar",
        onConfirmActionText: "A iniciar...",
        successMessage: "Exportação em fila. Consulte As minhas exportações para acompanhar o estado. Os emails seguem as suas preferências de notificações.",
        errorTitle: "Erro ao iniciar a exportação",
        errorMessage: "Não foi possível iniciar a exportação. Tente novamente.",
    },
    create: {
        title: "Pedir mudança de base de trabalho",
        confirmActionIcon: "mdi-plus",
        confirmActionText: "Criar pedido",
        onConfirmActionText: "Criando pedido...",
        successMessage: "Pedido criado com sucesso!",
        errorTitle: "Erro a criar pedido:",
        errorMessage: "Não foi possível criar o pedido! Tente novamente.",
    },
    update: {
        title: "Editar Pedido",
        confirmActionIcon: "mdi-content-save",
        confirmActionText: "Atualizar Pedido",
        onConfirmActionText: "Atualizando pedido...",
        successMessage: "Pedido atualizado com sucesso!",
        errorTitle: "Erro a atualizar pedido:",
        errorMessage: "Não foi possível atualizar o pedido! Tente novamente.",
    },
    approve: {
        title: "Aprovar Pedido",
        confirmActionIcon: "mdi-check",
        confirmActionText: "Aprovar Pedido",
        onConfirmActionText: "Aprovando pedido...",
        successMessage: "Pedido aprovado com sucesso!",
        errorTitle: "Erro a aprovar pedido:",
        errorMessage: "Não foi possível aprovar o pedido! Tente novamente.",
    },
    deny: {
        title: "Recusar Pedido",
        confirmActionIcon: "mdi-cancel",
        confirmActionText: "Recusar Pedido",
        onConfirmActionText: "Recusando pedido...",
        successMessage: "Pedido recusado com sucesso!",
        errorTitle: "Erro a recusar pedido:",
        errorMessage: "Não foi possível recusar o pedido! Tente novamente.",
    },
    delete: {
        title: "Apagar Pedido",
        confirmActionIcon: "mdi-delete",
        confirmActionText: "Apagar Pedido",
        confirmActionColor: "error",
        onConfirmActionText: "Apagando pedido...",
        successMessage: "Pedido apagado com sucesso!",
        errorTitle: "Erro a apagar pedido:",
        errorMessage: "Não foi possível apagar o pedido! Tente novamente.",
    },
    process: {
        title: "Marcar pedido como 'Processado'",
        confirmActionIcon: "mdi-send-check",
        confirmActionText: "Marcar como 'Processado'",
        onConfirmActionText: "Processando...",
        successMessage: "Pedido marcado como 'Processado' com sucesso!",
        errorTitle: "Erro ao marcar o pedido como 'Processado':",
        errorMessage: "Não foi possível marcar o pedido como 'processado'! Tente novamente.",
        confirmActionTextNotSkipping: "Marcar como 'Processado'",
        onConfirmActionTextNotSkipping: "Processando...",
        successMessageNotSkipping: "Pedido marcado como 'Processado' com sucesso!",
        errorTitleNotSkipping: "Erro ao marcar o pedido como 'Processado':",
        errorMessageNotSkipping: "Não foi possível marcar o pedido como 'processado'! Tente novamente.",
        confirmActionTextOnSkip: "Concluir Mudança",
        onConfirmActionTextOnSkip: "Concluíndo...",
        successMessageOnSkip: "Pedido 'Concluído' com sucesso!",
        errorTitleOnSkip: "Erro ao marcar o pedido como 'Concluído':",
        errorMessageOnSkip: "Não foi possível marcar o pedido como 'concluído'! Tente novamente.",
    },
};

const openDialogForAction = async (action = null, request = null) => {
    if (!action) {
        return;
    }

    if (!canOpenDialogForAction(action, request)) {
        return;
    }

    const componentProperties = resolveComponentPropertiesForAction(
        action,
        request,
    );

    componentProperties.idempotency_key = self?.crypto?.randomUUID() ?? null;
    componentProperties.onSubmit = createMembershipRequestSubmitHandler(action);
    
    const dialogOptions = resolveDialogOptionsForAction(action);
    let openedDialog = null;

    if(action === "process") {
        componentProperties.onSkipProcessingChange = (isSkippingProcessing) => {
            if (!openedDialog) {
                return;
            }
            openedDialog.options.confirmActionText = 
                isSkippingProcessing
                ? openedDialog.options.confirmActionTextOnSkip
                : openedDialog.options.confirmActionTextNotSkipping;
                
            openedDialog.options.onConfirmActionText = 
                isSkippingProcessing
                ? openedDialog.options.onConfirmActionTextOnSkip
                : openedDialog.options.onConfirmActionTextNotSkipping;
                
            openedDialog.options.successMessage = 
                isSkippingProcessing
                ? openedDialog.options.successMessageOnSkip
                : openedDialog.options.successMessageNotSkipping;
                
            openedDialog.options.errorTitle = 
                isSkippingProcessing
                ? openedDialog.options.errorTitleOnSkip
                : openedDialog.options.errorTitleNotSkipping;
                
            openedDialog.options.errorMessage = 
                isSkippingProcessing
                ? openedDialog.options.errorMessageOnSkip
                : openedDialog.options.errorMessageNotSkipping;
        }
    }

    const dialogPromise = dialog.open({
        component: action === "export" 
                    ? DepartmentMembershipRequestExportFields 
                    : DepartmentMembershipRequestForm,

        props: componentProperties,
        options: resolveDialogOptionsForAction(action),
    });

    openedDialog = dialog.state.stack.at(-1);

    await dialogPromise;
};

function canOpenDialogForAction(action, request) {
    const actionGuards = {
        create: () => canCreateMembershipRequest(),
        update: () => canEditRequest(request),
        approve: () => canApproveRequest(request),
        deny: () => canDenyRequest(request),
        delete: () => canDeleteRequest(request),
        process: () => canProcessRequest(request),
        export: () => canExportRequests(),
    };

    const guard = actionGuards[action];

    if (!guard) {
        throw new RangeError(`Invalid action: '${action}'.`);
    }

    return guard();
}

function resolveComponentPropertiesForAction(action, request) {
    if (!["create", "export",].includes(action) && !request) {
        throw new TypeError(
            `You need to provide a request for the '${action}' action.`,
        );
    }

    return {
        mode: action,
        request: request ? { ...request } : null,
        readonly: !["create", "update"].includes(action),
        disabled: false,
    };
}

function createMembershipRequestSubmitHandler(action) {
    const actionMethods = {
        create: (payload) => DepartmentMembershipRequest.create(payload),
        update: (payload) => DepartmentMembershipRequest.update(payload.id, payload),
        approve: (payload) => DepartmentMembershipRequest.approve(payload.id, payload),
        deny: (payload) => DepartmentMembershipRequest.deny(payload.id, payload),
        delete: (payload) => DepartmentMembershipRequest.delete(payload.id, payload),
        process: (payload) => DepartmentMembershipRequest.process(payload.id, payload),
        export: (payload) => DepartmentMembershipRequest.export(payload),
    };

    const actionMethod = actionMethods[action];

    if (!actionMethod) {
        throw new RangeError(`Invalid action: '${action}'.`);
    }

    return actionMethod;
}

function resolveDialogOptionsForAction(action) {
    const strategy = dialogActionStrategies[action];

    if (!strategy) {
        throw new RangeError(`Invalid action: '${action}'.`);
    }
    if(["export"].includes(action)) {
        strategy.onConfirmSuccess = async (result, currentDialog) => {
            await openSuccessDialog(strategy.successMessage);
            return true;
        }
    }
    else {
        strategy.onConfirmSuccess= async (result, currentDialog) => {
            fetchDepartmentMembershipRequests();
            await openSuccessDialog(strategy.successMessage);

            return result;
        };
    }
    return {
        titleBackgroundColor: "transparent",
        titleTextColor: "primary",
        persistent: true,
        maxWidth: 500,
        showCancel: false,
        confirmActionColor: "primary",
        onConfirm: "submit",
        onConfirmFailureExpectedResult: false,
        onConfirmFailureThrow: true,
        ...strategy,
        
        onConfirmError: (error, currentDialog) => {
            console.error(strategy.errorTitle, error);

            currentDialog.options.onConfirmFailedErrorTitle =
                error?.reason
                ?? strategy.errorTitle;

            currentDialog.options.onConfirmFailedErrorMessage =
                Object.values(error?.response?.data?.errors ?? {})
                    .flat()
                    .join("\n")
                || error?.response?.data?.message
                || error?.message
                || strategy.errorMessage
                || String(error);
        },
    };
}

async function openSuccessDialog(bodyText) {
    await dialog.open({
        options: {
            bodyText,
            persistent: true,
            maxWidth: 500,
            showCancel: false,
            confirmActionIcon: "",
            confirmActionText: "Ok",
            confirmActionColor: "primary",
        },
    });
}

function handleAssignedUsersMenuUpdate(isOpen) {
    if (isOpen) {
        return;
    }

    resetFilters();

    fetchDepartmentMembershipRequests();
}

function handleAssignedUsersClear() {
    resetFilters();

    fetchDepartmentMembershipRequests();
}

async function fetchUsers() {
    if(isLoadingUsersList.value) {
        return;
    }
    isLoadingUsersList.value = true;
    try {
        do {
            const response = await User.list({
                without_pending_membership_requests: 0,
                domain: "list__DepartmentMembershipRequests",
            });
            const isPaginated = response?.data?.data 
                                && response?.data?.current_page;
            const newUsers = isPaginated 
                                ? (response?.data?.data ?? [])
                                : (response?.data ?? []);

            if(isPaginated) {
                

                userListPagination.value = {
                    ...userListPagination.value,
                    from: response?.data?.from,
                    to: response?.data?.to,
                    per_page: response?.data?.per_page,
                    page: (response?.data?.current_page ?? 0) + 1,
                    total: response?.data?.total
                };
            } else {
                userListPagination.value = {
                    ...userListPagination.value,
                    from: 1,
                    to: response?.data?.length,
                    page: 1,
                    last_page: 1,
                    total: response?.data?.length,
                }
            }
            
            usersList.value = [
                    ...usersList.value,
                    ...newUsers
                ];
        
        } while (userListPagination.page <= userListPagination.last_page);
    } catch (error) {
        console.error(
            `Ocorreu um erro a obter a lista de utilizadores (pág: ${userListPagination?.page}/${userListPagination?.last_page}):`,
            error
        );
    } finally {
        isLoadingUsersList.value = false;
    }
    
}


onMounted(async () => {
    fetchDepartmentMembershipRequests();
    fetchUsers();
});
</script>

<style scoped>
</style>
